"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SubMenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _Row = _interopRequireDefault(require("../../baseComponents/Row"));
var _Col = _interopRequireDefault(require("../../baseComponents/Col"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BackButton = _interopRequireDefault(require("./BackButton"));
var _MenuItems = _interopRequireDefault(require("./MenuItems"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SubMenu = exports.SubMenu = function SubMenu(props) {
  var rightExtraComponents = props.rightToolComponents.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement(_Col["default"], {
      key: index,
      className: "subMenuRightTool"
    }, " ", element, " ");
  });
  var leftExtraComponents = props.leftToolComponents.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: "subMenuLeftTool"
    }, " ", element, " ");
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("submenu-component"),
    style: props.style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "menu-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "leftContainer"
  }, props.backButton != null && props.backButton.path != "" && props.backButton.text != "" && /*#__PURE__*/_react["default"].createElement(_BackButton["default"], {
    path: props.backButton.path,
    text: props.backButton.text,
    separator: props.backButton.separator
  }), props.menuItems != null && /*#__PURE__*/_react["default"].createElement(_MenuItems["default"], {
    content: props.menuItems
  }), props.leftToolComponents != [] && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("leftToolContainer", props.leftToolComponentsSeparator && "separator")
  }, leftExtraComponents)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rightContainer"
  }, rightExtraComponents)));
};
SubMenu.propTypes = {
  menuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    path: _propTypes["default"].string,
    text: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string, _propTypes["default"].number]),
    notification: _propTypes["default"].bool,
    count: _propTypes["default"].string,
    disabled: _propTypes["default"].bool
  })),
  backButton: _propTypes["default"].shape({
    path: _propTypes["default"].string,
    text: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string, _propTypes["default"].number]),
    separator: _propTypes["default"].bool,
    className: _propTypes["default"].string,
    style: _propTypes["default"].object
  }),
  rightToolComponents: _propTypes["default"].array,
  leftToolComponents: _propTypes["default"].array,
  leftToolComponentsSeparator: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
SubMenu.defaultProps = {
  menuItems: null,
  backButton: null,
  rightToolComponents: [],
  leftToolComponents: [],
  className: "",
  style: {}
};
var _default = exports["default"] = SubMenu;